import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import { install as dvLabelAlignEdgeExtensionInstall } from './dvLabelAlignEdge';
import { install as dvPaddingExtensionInstall } from './dvPadding';
import { install as dvSplitLineNumberExtensionInstall } from './dvSplitLineNumber';
import { install as extendSplitLineExtensionInstall } from './extendSplitLine';
import { install as extendLabelWidthExtensionInstall } from './extendLabelWidth';
import { install as extendExtensionZInstall } from './extendZ';
import { install as extendNameLocationExtensionInstall } from './extendNameLocation';

export function install(registers: EChartsExtensionInstallRegisters) {
  dvLabelAlignEdgeExtensionInstall(registers);
  dvPaddingExtensionInstall(registers);
  dvSplitLineNumberExtensionInstall();
  extendSplitLineExtensionInstall(registers);
  extendLabelWidthExtensionInstall(registers);
  extendExtensionZInstall(registers);
  extendNameLocationExtensionInstall(registers);
}
